import type {
  GenerateCorpCodesArgs,
  FetchCorpCodesArgs,
} from './types/corpCodes.types';
import type { BaseApiPaginatedResponse } from './types/api.types';
import type { ApiCorpCode } from '../schemas/corpCodes.schema';

import { mapCorpCodeFromApi } from './mappers/corpCodes.mappers';
import { post, get } from './axios';

export async function fetchCorpCodes({
  corpOrganizationId,
  filters,
}: FetchCorpCodesArgs) {
  const response = await get<BaseApiPaginatedResponse<ApiCorpCode[]>>(
    `/v2/corp-organizations/${corpOrganizationId}/codes`,
    {
      query: filters,
    },
  );
  return {
    ...response,
    data: response?.data?.map(mapCorpCodeFromApi),
  };
}

export async function generateCorpCodes({
  corpOrganizationId,
  count,
}: GenerateCorpCodesArgs) {
  const response = await post<ApiCorpCode[]>(
    `/v2/corp-organizations/${corpOrganizationId}/codes/generate`,
    { count },
  );
  return {
    ...response,
    data: response?.data?.map(mapCorpCodeFromApi),
  };
}
